import React, { useState, useEffect } from "react"
import { Table, Typography } from 'antd'

import { formatDateTime } from "../../helpers/date";

const WeightDisputeByMerchantList = props =>{
  const [weightDisputes, setWeightDisputes] = useState(props.weightDisputes)

  useEffect(() => {
    setWeightDisputes(props.weightDisputes);
  }, [props.weightDisputes])

  const table = [
    {
      title: "Merchant",
      dataIndex: ["user"],
      width: 280,
      render: user => `${user.countryCode || ""}${user.phone || ""} (${user.email || ""})`
    },
    {
      title: "Current Credit",
      dataIndex: ["merchant", "credits"],
      width: 110,
      render: credits => Number(credits) < 0 
        ? <Typography.Text type="danger">{credits?.toFixed(2)}</Typography.Text>
        : credits?.toFixed(2)
    },
    {
      title: "Count",
      dataIndex: "count",
      width: 80,
    },
    {
      title: "Max Weight Diff (RM)",
      dataIndex: "maxWeightDiff",
      width: 120,
      render: text => text?.toFixed(2)
    },
    {
      title: "Total Weight Diff (RM)",
      dataIndex: "totalWeightDiff",
      width: 120,
      render: text => <Typography.Text type="danger">{text?.toFixed(2)}</Typography.Text>
    },
    {
      title: "Max Price Diff (RM)",
      dataIndex: "maxPriceDiff",
      width: 120,
      render: text => text?.toFixed(2)
    },
    {
      title: "Total Price Diff (RM)",
      dataIndex: "totalPriceDiff",
      width: 120,
      render: text => <Typography.Text type="danger">{text?.toFixed(2)}</Typography.Text>
    },
    {
      title: "Last Dispute At",
      dataIndex: "lastCreatedAt",
      width: 130,
      render: text => formatDateTime(text)
    },
    {
      title: "Last Login At",
      dataIndex: ["user", "lastLoginAt"],
      width: 130,
      render: text => text ? formatDateTime(text) : "-"
    },
  ];

  return (
      <div className="table">
        <Table
          rowKey="objectId"
          className="table-section"
          columns={table}
          dataSource={weightDisputes}
          pagination={false}
          scroll={{ x: 1300, y: 600 }}
          loading={props.loading}
        />
      </div>
    )
}

export default WeightDisputeByMerchantList
